import React, { useState, useEffect } from "react";
import UploadFile from "./UploadFiles";
import "../../style/Fournisseur.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import AdminFournisseursVerresAdresse from "./AdminFournisseurVerresAdresse";

import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";

import AdminAjoutFournisseur from "./AdminAjoutFournisseur";

const API_URL = process.env.REACT_APP_API_URL;

function AdminFournisseurVerres() {
  const [fournisseur, setFournisseur] = useState([]);
  const { fournisseurId } = useParams();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    function getFournisseur() {
      axios
        .get(`${API_URL}/api/verriers/${fournisseurId}`)
        .then((res) => res.data)
        .then((data) => {
          setFournisseur(data);
        });
    }

    getFournisseur();
  }, []);

  return (
    <div>
      <div className="fournisseurMain">
        <a
          href={fournisseur.site_internet}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>
            {fournisseur[0] ? (
              <img
                src={`${API_URL}/images/fournisseurs-verres/${fournisseur[0].fournisseur_verre_id}.png`}
                alt="Logo"
                className="fournisseurLogo"
              />
            ) : (
              "Loading"
            )}
            <h1>
              {fournisseur[0]
                ? `${fournisseur[0].nomFournisseur
                    .charAt(0)
                    .toUpperCase()}${fournisseur[0].nomFournisseur.slice(1)}`
                : null}
            </h1>
          </span>
        </a>
        <h2>Liste des adresses</h2>
        <MDBBtn type="button" outline color="primary" onClick={handleShow}>
          Ajouter une agence
        </MDBBtn>
        <div className="adressesList">
          {fournisseur[0] &&
            fournisseur.map((adresse) => (
              <AdminFournisseursVerresAdresse {...adresse} />
            ))}
        </div>
        <UploadFile id={fournisseurId} category={"verres"} />
      </div>
      <MDBContainer>
        <MDBModal isOpen={show} toggle={handleClose}>
          <MDBModalHeader>Créer une mutuelle </MDBModalHeader>
          <MDBModalBody>
            <AdminAjoutFournisseur
              category="verriers/agence"
              fournisseurId={fournisseurId}
            />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" outline color="primary" onClick={handleClose}>
              Fermer
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default AdminFournisseurVerres;
